export default class CustomApiError {
  constructor(response) {
    if (this.constructor === CustomApiError) {
      throw new Error("Can't instantiate abstract class!");
    }
    this.response = response;
  }

  getMessage() {
    const dictionary = this.toDictionary();
    const message = dictionary[this.response.error];
    return message ? message : 'Parece que tivemos um pequeno problema.';
  }

  toDictionary() {
    return {};
  }
}
